import HomeHub from "../components/hub/HomeHub";
import Layout from "../components/Layout";
import { useTranslation } from "../hooks/useTranslation";

const Home = () => {
  const { t } = useTranslation();
  const siteUrl = import.meta.env?.VITE_SITE_URL || "https://lenz3.com";

  return (
    <Layout
      title={t("hub.pageTitle")}
      description={t("hub.pageDescription")}
      canonical={`${siteUrl}/`}
    >
      <HomeHub />
    </Layout>
  );
};

export default Home;
